const googleMapKey = "AIzaSyAowl-8dlH1jzpQWDMQhq-whq4-PDb8pJ4"  // STG
// const googleMapKey = "AIzaSyCKCXV_Tcy2YErfxYWgtgTEuKhojCD-PzY"  // DEV

// const bingmapKey = "AoTV4dYJAOdyg9A-8hFPHtbZvVSV1H0vpb0q71EJToPWRLc4J0CfRw4jL77cblPP"
const bingmapKey = "AgM3Wmy3plVeOwPqw3rL2r2-a-xKaDRg8CjyhQwhX9RJ3su5TjCTzBKIilww-7h3"
export {bingmapKey, googleMapKey}
